const AccountSettingsGoogleIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="40" height="40" rx="8" fill="#F1F3F9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.8299 20.1818C27.8299 19.6145 27.779 19.069 27.6845 18.5454H20.1499V21.64H24.4554C24.2699 22.64 23.7063 23.4872 22.859 24.0545V26.0618H25.4445C26.9572 24.6691 27.8299 22.6181 27.8299 20.1818Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1496 28C22.3096 28 24.1205 27.2837 25.4442 26.0618L22.8587 24.0546C22.1423 24.5346 21.226 24.8182 20.1496 24.8182C18.066 24.8182 16.3023 23.4109 15.6732 21.52H13.0005V23.5928C14.3169 26.2073 17.0223 28 20.1496 28Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6735 21.52C15.5135 21.04 15.4226 20.5272 15.4226 20C15.4226 19.4727 15.5135 18.96 15.6735 18.48V16.4072H13.0008C12.459 17.4872 12.1499 18.709 12.1499 20C12.1499 21.2909 12.459 22.5127 13.0008 23.5927L15.6735 21.52Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1496 15.1818C21.3241 15.1818 22.3787 15.5855 23.2078 16.3782L25.5023 14.0836C24.1169 12.7927 22.306 12 20.1496 12C17.0223 12 14.3169 13.7927 13.0005 16.4073L15.6732 18.48C16.3023 16.5891 18.066 15.1818 20.1496 15.1818Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export default AccountSettingsGoogleIcon;
